import { useEffect, useRef } from 'react'

export function useDidMountEffect(
  callback: () => void,
  deps: unknown[] = []
): void {
  const didMount = useRef(false)

  useEffect(() => {
    if (didMount.current) {
      callback()
    } else {
      didMount.current = true
    }
  }, deps)
}
